import { Uuids } from '@standardnotes/utils';
export class DiscardItemsLocally {
    constructor(items, storage) {
        this.items = items;
        this.storage = storage;
    }
    async execute(items) {
        this.items.removeItemsFromMemory(items);
        await this.storage.deletePayloadsWithUuids(Uuids(items));
    }
}
